export default {
  "root": "_root_1ajs2_1",
  "input": "_input_1ajs2_1",
  "--size-medium": "_--size-medium_1ajs2_1",
  "--size-large": "_--size-large_1ajs2_1",
  "--size-xlarge": "_--size-xlarge_1ajs2_1",
  "--variant-faded": "_--variant-faded_1ajs2_1",
  "--variant-headless": "_--variant-headless_1ajs2_1",
  "--status-error": "_--status-error_1ajs2_1",
  "--resize-auto": "_--resize-auto_1ajs2_1",
  "--resize-none": "_--resize-none_1ajs2_1",
  "--size-medium--m": "_--size-medium--m_1ajs2_1",
  "--size-large--m": "_--size-large--m_1ajs2_1",
  "--size-xlarge--m": "_--size-xlarge--m_1ajs2_1",
  "--size-medium--l": "_--size-medium--l_1ajs2_1",
  "--size-large--l": "_--size-large--l_1ajs2_1",
  "--size-xlarge--l": "_--size-xlarge--l_1ajs2_1",
  "--size-medium--xl": "_--size-medium--xl_1ajs2_1",
  "--size-large--xl": "_--size-large--xl_1ajs2_1",
  "--size-xlarge--xl": "_--size-xlarge--xl_1ajs2_1"
};import "ni:sha-256;V4r0MtryVcW_4N5hr1O0ZBrmbh_cNWRWTnAa_wAyCH4";